exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".role-list[data-v-c0614da6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.role-list .role-item[data-v-c0614da6] {\n  background: #018801;\n  color: #fff;\n  border-radius: 2px;\n  padding: 0 3px;\n  text-align: center;\n  margin: 2px;\n}\n.pagination-wrap[data-v-c0614da6] {\n  text-align: right;\n  margin-top: 20px;\n}\n", ""]);

// exports
